__turbopack_context__.v({
  "buttonWrapper": "showmorecatagory-module-scss-module__DRZ6wG__buttonWrapper",
  "contentText": "showmorecatagory-module-scss-module__DRZ6wG__contentText",
});
